import React, { FC } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { palette } from '../../theme';

/**
 * Displays a red caption beneath a field row when `message` is truthy.
 * Renders nothing when there is no error message.
 */
export const FieldErrorCaption: FC<{ message?: string }> = ({ message }) => {
  if (!message) return null;
  return (
    <Typography variant="caption" color="error" sx={{ display: 'block', px: 2, pb: 1, pt: 0.25 }}>
      {message}
    </Typography>
  );
};

/**
 * Applies a red inset box-shadow + background tint to a field row when it is
 * invalid.  Uses `box-shadow` instead of `border` so the layout never shifts.
 */
export const errorRowSx = {
  backgroundColor: palette.error.light,
  boxShadow: `inset 0 0 0 1px ${palette.error.main}`,
} as const;

/**
 * Renders a small icon box (32×32) used beside modal rows.
 * When `isError` is true the icon flips to the error color palette.
 */
export const iconBox = (bg: string, color: string, icon: React.ReactNode, isError?: boolean): JSX.Element => (
  <Box
    sx={{
      width: 32,
      height: 32,
      borderRadius: 1.5,
      bgcolor: isError ? palette.error.light : bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: isError ? palette.error.main : color,
      flexShrink: 0,
      transition: 'background-color 0.15s ease, color 0.15s ease',
    }}
  >
    {icon}
  </Box>
);
